import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import type { BulkCandidateJobFeedbackRequestApi } from '@/modules/candidates/types';
import { invalidateQuery } from '@/utils/queries';

interface CreateBulkCandidateFeedbackParams {
  jobId: string;
  body: BulkCandidateJobFeedbackRequestApi;
}

export const useCreateBulkCandidateFeedbackMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, body }: CreateBulkCandidateFeedbackParams) => {
      const { data } = await fetchClient.POST(
        candidateEndpoints.bulkCandidateFeedback,
        {
          params: { path: { jobId } },
          body,
        },
      );
      return data;
    },
    onSettled: (_data, _error, variables) => {
      invalidateQuery(candidateJobQueryKeys.lists(variables.jobId))();
    },
  });
};
